import { render, staticRenderFns } from "./censor-add.vue?vue&type=template&id=69f30760&scoped=true&"
import script from "./censor-add.vue?vue&type=script&lang=js&"
export * from "./censor-add.vue?vue&type=script&lang=js&"
import style0 from "./censor-add.vue?vue&type=style&index=0&id=69f30760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f30760",
  null
  
)

export default component.exports